import { render } from "./Shortcut.vue?vue&type=template&id=5d54c9d8"
import script from "./Shortcut.vue?vue&type=script&lang=js"
export * from "./Shortcut.vue?vue&type=script&lang=js"

import "./Shortcut.vue?vue&type=style&index=0&id=5d54c9d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__